import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AutoCompleteComponent } from 'auto-complete-lib';
import { EntityControllerService } from 'entity-picker-lib';
import { EntityType, IEntityMetadata, IPickerInfo, ISharedServiceProviderService } from 'interfaces-lib';
import { MessageNotificationService } from 'message-notification-service-lib';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { IdentityStorage } from 'storage-service-lib';

@Component({
  selector: 'app-entity-picker',
  template: ` <app-kp-autocomplete
    [filterFunction]="this.queryFn.bind(this)"
    (selectedChange)="entitySelected($event)"
    [placeholder]="placeholderText"
    [focusInputOnLoad]="true"
    [embeddedDropDown]="embedded"
    [inputWidth]="'369px'"
    [entitiesMeta]="entitiesMeta"
    [showItemTooltip]="true"
    [showItemIconTooltip]="true"
  ></app-kp-autocomplete>`,
  imports: [AutoCompleteComponent],
})
export class EntityPickerComponent {
  @Input()
  embedded = false;

  @Input()
  searchTypes?: EntityType[];

  @Output()
  selected = new EventEmitter<IPickerInfo>();

  placeholderText = 'Search (Ctrl+Shift+F)...';

  entitiesMeta?: IEntityMetadata[];
  sps: ISharedServiceProviderService;

  constructor(
    private identityStorage: IdentityStorage,
    private serviceProviderService: SharedServiceProviderServiceFactory,
    private messageNotificationService: MessageNotificationService,
    private entityControllerService: EntityControllerService
  ) {
    this.sps = this.serviceProviderService.getServiceProviderService(this.identityStorage.get()?.namespace);
    this.sps
      .getEntityMetadataService()
      .getEntitiesMetadata()
      .subscribe((entitiesMeta: any) => {
        this.entitiesMeta = entitiesMeta;
      });
  }

  // NOTE: return type is actually an array IPickerInfo objects, but IPickerInfo matches the signature specified
  queryFn(filterValue: string): Observable<{ label: string }[]> {
    if (filterValue.length === 0) {
      return of([]);
    }

    return this.sps
      .getEntityPickerService()
      .findMatches(filterValue, this.searchTypes)
      .pipe(
        catchError((error) => {
          // For example, Invenias has a minimum search length of 2
          if (error.status !== 400) {
            this.messageNotificationService.error('Error during search.', error);
          }
          return of([]);
        })
      );
  }

  entitySelected(entityInfo: IPickerInfo): void {
    this.selected.emit(entityInfo);
    this.entityControllerService.entitySelected(entityInfo?.entity);
  }
}
